/* Pin High: custom hat cart guard.
   - Hats that share a logo (_dyo_logo) are priced on their combined quantity: each line is moved
     to the price-tier variant for that combined quantity (across colors and styles).
   - Minimum 12 hats per logo; lines with _dyo_min=48 (woven/embroidered/PVC patch) need 48 combined.
   - Upcharge lines (_dyo_role=addon) follow their hat's quantity and are restored if removed.
   - Creator logos: cart attributes "creators" and "creator_logos" list the creators/logos in the cart
     (copied to the order as Additional details, for profit-share tracking). */
(function () {
  'use strict';
  var MIN = 12, busy = false, again = false, maps = {};
  var NOTE_KEY = 'phDyoNote';
  function j(url, opt) { return fetch(url, opt).then(function (r) { return r.json(); }); }
  function post(url, body) { return j(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }
  function tierIndex(tiers, q) { var i = 0; tiers.forEach(function (t, k) { if (q >= (parseInt(t, 10) || 0)) i = k; }); return i; }
  function getMap(handle) {
    if (!maps[handle]) maps[handle] = j('/products/' + handle + '?view=dyo-map').catch(function () { return null; });
    return maps[handle];
  }
  function opt(item, name) { var o = (item.options_with_values || []).filter(function (x) { return x.name === name; })[0]; return o && o.value; }
  function isCartPage() { return !!document.querySelector('cart-items, #main-cart-items'); }

  function plan(cart) {
    var hats = [], adds = {}, notes = [];
    cart.items.forEach(function (it) {
      var p = it.properties || {}, id = p._dyo_id; if (!id) return;
      if (p._dyo_role === 'hat') hats.push(it); else (adds[id] = adds[id] || []).push(it);
    });
    if (!hats.length && !Object.keys(adds).length) return Promise.resolve(null);
    return Promise.all(hats.map(function (h) { return getMap(h.handle); })).then(function () {
      var ops = [], hatIds = {};
      hats.forEach(function (h) { hatIds[h.properties._dyo_id] = 1; h._q = h.quantity; });
      Object.keys(adds).forEach(function (id) {
        if (!hatIds[id]) adds[id].forEach(function (a) { ops.push({ t: 'qty', key: a.key, q: 0 }); });
      });
      /* group by logo */
      var groups = {};
      hats.forEach(function (h) { var k = h.properties._dyo_logo || h.properties._dyo_id; (groups[k] = groups[k] || []).push(h); });
      var waits = Object.keys(groups).map(function (k) {
        var g = groups[k];
        function biggest(list) { return list.slice().sort(function (a, b) { return b._q - a._q; })[0]; }
        var patch = g.filter(function (h) { return +h.properties._dyo_min > MIN; });
        if (patch.length) {
          var pm = Math.max.apply(null, patch.map(function (h) { return +h.properties._dyo_min; }));
          var pq = patch.reduce(function (s, h) { return s + h._q; }, 0);
          if (pq < pm) { biggest(patch)._q += pm - pq; notes.push('Woven, embroidered and PVC patches need at least ' + pm + ' hats per logo, so we raised that line to meet the minimum.'); }
        }
        var tot = g.reduce(function (s, h) { return s + h._q; }, 0);
        if (tot < MIN) { biggest(g)._q += MIN - tot; tot = MIN; notes.push('Custom hats have a ' + MIN + ' hat minimum per logo, so we raised your quantity to ' + MIN + '.'); }
        return Promise.all(g.map(function (h) {
          return getMap(h.handle).then(function (map) {
            var q = h._q, id = h.properties._dyo_id;
            var want = map && map.v && map.v[opt(h, 'Color')] && map.v[opt(h, 'Color')][tierIndex(map.t, tot)];
            if (want && want !== h.variant_id) ops.push({ t: 'swap', key: h.key, id: want, q: q, props: h.properties });
            else if (q !== h.quantity) ops.push({ t: 'qty', key: h.key, q: q });
            var list = String(h.properties._dyo_addons || '').split(',').filter(Boolean).map(Number);
            var have = adds[id] || [];
            have.forEach(function (a) { if (a.quantity !== q) ops.push({ t: 'qty', key: a.key, q: q }); });
            list.forEach(function (vid) {
              if (!have.some(function (a) { return a.variant_id === vid; }))
                ops.push({ t: 'add', id: vid, q: q, props: { _dyo_id: id, _dyo_role: 'addon', For: h.product_title + ' / ' + (opt(h, 'Color') || '') } });
            });
          });
        }));
      });
      return Promise.all(waits).then(function () { return { ops: ops, notes: notes }; });
    });
  }
  function run(ops) {
    /* One update for every removal/quantity change, then one add for every new line, so line keys never go stale mid-way. */
    var updates = {}, items = [], n = 0;
    ops.forEach(function (o) {
      if (o.t === 'qty') { updates[o.key] = o.q; n++; }
      if (o.t === 'swap') { updates[o.key] = 0; n++; items.push({ id: o.id, quantity: o.q, properties: o.props }); }
      if (o.t === 'add') items.push({ id: o.id, quantity: o.q, properties: o.props });
    });
    var p = n ? post('/cart/update.js', { updates: updates }) : Promise.resolve();
    return p.then(function () { if (items.length) return post('/cart/add.js', { items: items }); });
  }
  function decorate(cart) {
    if (!isCartPage()) return;
    var totals = {};
    cart.items.forEach(function (it) { var p = it.properties || {}; if (p._dyo_role === 'hat') { var k = p._dyo_logo || p._dyo_id; totals[k] = (totals[k] || 0) + it.quantity; } });
    cart.items.forEach(function (it, i) {
      var p = it.properties || {}; if (!p._dyo_id) return;
      var row = document.getElementById('CartItem-' + (i + 1)); if (!row) return;
      var inp = row.querySelector('input[name="updates[]"], .quantity__input');
      if (p._dyo_role === 'addon') {
        row.classList.add('ph-dyo-addon');
        row.querySelectorAll('.quantity__button, cart-remove-button, .cart-remove-button').forEach(function (b) { b.style.display = 'none'; });
        if (inp) { inp.readOnly = true; inp.setAttribute('aria-readonly', 'true'); inp.tabIndex = -1; }
      } else if (p._dyo_role === 'hat' && !row.querySelector('.ph-dyo-more')) {
        var k = p._dyo_logo || p._dyo_id, cell = row.querySelector('.cart-item__details') || row;
        var d = document.createElement('div'); d.className = 'ph-dyo-more';
        d.style.cssText = 'margin-top:8px;font-size:1.3rem;';
        var t = document.createElement('div'); t.textContent = 'Priced at the ' + totals[k] + ' hat tier (all hats with this logo).'; d.appendChild(t);
        if (p._dyo_logo) {
          var a = document.createElement('a'); a.href = '/products/' + it.handle + '?dyo_logo=' + encodeURIComponent(p._dyo_logo);
          a.textContent = '+ Add another color with this logo'; a.style.cssText = 'color:#114c34;font-weight:600;'; d.appendChild(a);
        }
        cell.appendChild(d);
      }
    });
    if (!document.querySelector('.ph-dyo-proof') && cart.items.some(function (it) { return (it.properties || {})._dyo_role === 'hat'; })) {
      var pf = document.createElement('p'); pf.className = 'ph-dyo-proof';
      pf.style.cssText = 'background:#114c34;color:#f6f1e3;border-left:4px solid #fce477;padding:10px 14px;margin:0 0 16px;font-size:1.4rem;';
      pf.innerHTML = '<strong style="color:#fce477">&#10003; Free pre-production proof within 24 hours.</strong> Nothing goes into production until you approve it.';
      var ph = document.querySelector('cart-items, #main-cart-items'); ph.parentNode.insertBefore(pf, ph);
    }
    var msg = null; try { msg = sessionStorage.getItem(NOTE_KEY); sessionStorage.removeItem(NOTE_KEY); } catch (e) {}
    if (msg && !document.querySelector('.ph-dyo-note')) {
      var n = document.createElement('p'); n.className = 'ph-dyo-note'; n.setAttribute('role', 'status');
      n.style.cssText = 'background:#f6f1e3;border-left:4px solid #114c34;padding:10px 14px;margin:0 0 16px;font-size:1.4rem;';
      n.textContent = msg;
      var host = document.querySelector('cart-items, #main-cart-items'); host.parentNode.insertBefore(n, host);
    }
  }
  function creatorAttrs(cart) {
    var names = [], qty = {}, order = [];
    cart.items.forEach(function (it) {
      var p = it.properties || {}; if (p._dyo_role !== 'hat' || !p.Creator) return;
      if (names.indexOf(p.Creator) < 0) names.push(p.Creator);
      var k = p.Creator + ': ' + (p['Logo name'] || '') + (p['Logo color'] ? ' (' + p['Logo color'] + ')' : '');
      if (!(k in qty)) { qty[k] = 0; order.push(k); }
      qty[k] += it.quantity;
    });
    return { creators: names.join(', '), creator_logos: order.map(function (k) { return k + ' x ' + qty[k]; }).join('; ') };
  }
  function syncCreators(cart) {
    var want = creatorAttrs(cart), have = cart.attributes || {};
    if ((have.creators || '') === want.creators && (have.creator_logos || '') === want.creator_logos) return Promise.resolve();
    return post('/cart/update.js', { attributes: want }).catch(function () {});
  }
  function check() {
    if (busy) { again = true; return; }
    busy = true;
    j('/cart.js').then(function (cart) {
      return plan(cart).then(function (res) {
        if (!res || !res.ops.length) { decorate(cart); return syncCreators(cart).then(function () { return false; }); }
        if (res.notes.length) { try { sessionStorage.setItem(NOTE_KEY, res.notes.filter(function (v, i, a) { return a.indexOf(v) === i; }).join(' ')); } catch (e) {} }
        return run(res.ops).then(function () { return true; });
      });
    }).then(function (changed) {
      busy = false;
      if (changed) {
        if (isCartPage()) { location.reload(); return; }
        fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
          var el = document.getElementById('cart-icon-bubble');
          if (el && s['cart-icon-bubble']) el.innerHTML = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section').innerHTML;
        }).catch(function () {});
      }
      if (again) { again = false; check(); }
    }).catch(function () { busy = false; });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(check, 400); }
  function boot() {
    check();
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
